import * as rxjs from "rxjs";
import MuseumRoomState from "../models/MuseumRoomState";

class MuseumRoomBloc {
    constructor( roomState ) {
        this.currentState   = new MuseumRoomState({
            galleries: roomState.room.museum_fields.galleries,
        });
        this.stateSubject   = new rxjs.BehaviorSubject(this.currentState);
    }

    openGallery(gallery) {
        this.currentState.currentGallery = gallery;
        this.pushState();
    }

    closeGallery() {
        this.currentState.currentGallery = null;
        this.pushState();
    }

    getSubject = () => this.stateSubject;

    pushState( newState = this.currentState ) {
        let state = newState ?? this.currentState;
        this.stateSubject.next(state);
    }
}

export default MuseumRoomBloc;
